import React, { useState } from "react";
import { useNotification } from "../components/Notifications";
import { apiFetch } from "../api/client";
import { mapApiErrorToNotification } from "../utils/notificationHelpers";
import { useNavigate } from "react-router-dom";

export default function ChangePassword() {
    const [form, setForm] = useState({ currentPassword: "", newPassword: "", confirmPassword: "" });
    const [loading, setLoading] = useState(false);
    const notify = useNotification();
    const navigate = useNavigate();

    const localUser = (() => {
        try {
            return JSON.parse(localStorage.getItem("user")) || {};
        } catch (e) {
            return {};
        }
    })();

    const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

    const submit = async (e) => {
        e.preventDefault();

        if (!form.currentPassword || !form.newPassword || !form.confirmPassword) {
            notify("error", { title: "Validation", text: "All fields are required." });
            return;
        }

        if (form.newPassword !== form.confirmPassword) {
            notify("error", { title: "Validation", text: "New password and confirmation do not match." });
            return;
        }

        setLoading(true);

        try {
            const payload = {
                email: localUser.email || localUser?.emailAddress || "",
                currentPassword: form.currentPassword,
                newPassword: form.newPassword,
            };

            if (!payload.email) {
                notify("error", { title: "Error", text: "Unable to determine your email address. Please login again." });
                setLoading(false);
                return;
            }

            const res = await apiFetch(`/api/account/change-password`, {
                method: "POST",
                body: JSON.stringify(payload),
            });

            if (!res.ok) {
                let parsed = null;
                try {
                    parsed = await res.json();
                } catch (err) {
                    notify("error", { title: "Change failed", text: res.statusText });
                    setLoading(false);
                    return;
                }

                const note = mapApiErrorToNotification(parsed, res.status);
                notify("error", note);
                setLoading(false);
                return;
            }

            const data = await res.json();
            if (data?.succeeded) {
                notify("success", { title: "Password changed", text: data.message || "Password changed successfully." });
                setForm({ currentPassword: "", newPassword: "", confirmPassword: "" });
                navigate("/");
            } else {
                const note = mapApiErrorToNotification(data, res.status);
                notify("error", note);
            }
        } catch (err) {
            console.error(err);
            notify("error", { title: "Network error", text: "Could not reach server." });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-md mx-auto mt-8 bg-white p-6 rounded shadow">
            <h2 className="text-xl font-semibold mb-4">Change password</h2>
            <form onSubmit={submit}>
                <div className="mb-3">
                    <label className="block text-sm font-medium mb-1">Current password</label>
                    <input
                        name="currentPassword"
                        type="password"
                        value={form.currentPassword}
                        onChange={handleChange}
                        className="w-full rounded border px-3 py-2"
                        required
                    />
                </div>

                <div className="mb-3">
                    <label className="block text-sm font-medium mb-1">New password</label>
                    <input
                        name="newPassword"
                        type="password"
                        value={form.newPassword}
                        onChange={handleChange}
                        className="w-full rounded border px-3 py-2"
                        required
                    />
                </div>

                <div className="mb-4">
                    <label className="block text-sm font-medium mb-1">Confirm new password</label>
                    <input
                        name="confirmPassword"
                        type="password"
                        value={form.confirmPassword}
                        onChange={handleChange}
                        className="w-full rounded border px-3 py-2"
                        required
                    />
                </div>

                <div>
                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full bg-indigo-600 text-white py-2 rounded hover:bg-indigo-700 disabled:opacity-70"
                    >
                        {loading ? "Changing..." : "Change password"}
                    </button>
                </div>
            </form>
        </div>
    );
}

